export default "__VITE_ASSET__a9RjY4wp__"